<template>
  <div class="badges-filter-main">
    <div class="badges-type">
      <ul class="is-flex">
        <!-- <li>
            <input class="is-checkradio" v-model="filter.type" id="exclusive_badges" type="checkbox" value="exclusive">
            <label for="exclusive_badges" class=""><span class="badge-tag">EXCLUSIVE</span> only</label>
        </li> -->
        <li>
          <input class="is-checkradio" v-model="filters.type" id="expired_badges" type="checkbox" value="expired">
          <label for="expired_badges" class="">Coming Soon</label>
        </li>
      </ul>
    </div>
    <div class="badges-sort-type">
      <!-- <label for="badge_sort_by" class=" sort-by-label has-text-weight-semibold">
        <span class="has-text-weight-normal">Sort by: </span>
        <select id="badge_sort_by" v-model="filter.sort" class="badge-short">
          <option value="low">Progress: Low - High</option>
          <option value="high">Progress: High - Low</option>
        </select>
      </label> -->
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    filters: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({
    }),
  },
  
  async mounted() {
  },

  methods: {
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>
